module.exports = __webpack_public_path__ + "5c114213/img/note-list-icon.961c1485.svg";